// Never log the copied text: it can be a secret (MFA recovery codes, API keys, a webhook token header) and console
// output reaches Sentry as breadcrumbs. Failures are logged without the value or the error's message.
// copyTextToClipboard answers a promise of whether the text was copied (callers may ignore it): the Clipboard API,
// else (absent, or refused) the execCommand fallback.
const logFailure = (how, err) => {
    console.warn(`Copying to the clipboard failed (${how})${err && err.name ? `: ${err.name}` : ''}`);
};

function fallbackCopyTextToClipboard(text) {
    var textArea = document.createElement("textarea");
    textArea.value = text;
    
    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";
  
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
  
    let copied = false;
    try {
      copied = !!document.execCommand('copy');
      if (!copied) {
        logFailure('fallback');
      }
    } catch (err) {
      logFailure('fallback', err);
    }
  
    document.body.removeChild(textArea);
    return copied;
  }
  export const copyTextToClipboard = (text) => {
    if (!navigator.clipboard) {
      return Promise.resolve(fallbackCopyTextToClipboard(text));
    }
    return navigator.clipboard.writeText(text).then(() => true, (err) => {
      logFailure('async', err);
      return fallbackCopyTextToClipboard(text);
    });
  }
  
  export default copyTextToClipboard;
